// checkout script extends category script
import "~/base";

import "ceres/app/components/checkout/AcceptGtcCheck";
import "ceres/app/components/checkout/Checkout";
import "ceres/app/components/checkout/ContactWishInput";
import "ceres/app/components/checkout/CustomerSignInput";
import "ceres/app/components/checkout/PaymentProviderSelect";
import "ceres/app/components/checkout/PlaceOrder";

import "ceres/app/components/checkout/ShippingPrivacyHintCheck";
import "ceres/app/components/checkout/ShippingProfileSelect";
import "ceres/app/components/checkout/SubscribeNewsletterCheck";
import BasketItemConsentCheck from "ceres/app/components/checkout/BasketItemConsentCheck.vue";
Vue.component("basket-item-consent-check", BasketItemConsentCheck);

import "ceres/app/components/customer/AddressSelect/AddressHeader";
import "~/app/components/customer/AddressSelect/InvoiceAddressSelect";
import "~/app/components/customer/AddressSelect/ShippingAddressSelect";

import "ceres/app/components/myAccount/AccountSettings";
import "ceres/app/components/myAccount/BankDataSelect";
import "ceres/app/components/myAccount/ChangePaymentMethod";
import "ceres/app/components/myAccount/MyAccount";
import "ceres/app/components/myAccount/OrderDocuments";

// legacy non-shopbuilder components
import "ceres/app/components/myAccount/History";

// new shopbuilder-only component
import EditCouponOverlay from "ceres/app/components/myAccount/EditCouponOverlay.vue";
Vue.component("edit-coupon-overlay", EditCouponOverlay);
import "ceres/app/components/myAccount/OrderHistoryList";
import "ceres/app/components/myAccount/OrderReturnHistoryList";
